import { Injectable } from '@angular/core';
import { map } from 'rxjs';

import { Sport, SportsEnum } from '../../models/sport';
import { Store } from '../../../../shared/store';
import { SportState } from './sport.state';

const sportState = new SportState();
sportState.sports = [
  { name: SportsEnum.Cycling, label: 'cycling' },
  { name: SportsEnum.Running, label: 'running' },
  { name: SportsEnum.Rowing, label: 'rowing' },
];
sportState.selectedSport = sportState.sports[0];

@Injectable({ providedIn: 'root' })
export class SportStore extends Store<SportState> {
  sports$ = this.state$.pipe(map((s) => s.sports));
  selectedSport$ = this.state$.pipe(map((s) => s.selectedSport));

  constructor() {
    super(sportState);
  }

  setSelectedSport(nextSelectedSport: Sport): void {
    if (this.state.selectedSport === nextSelectedSport) {
      return;
    }
    this.setState({ ...this.state, selectedSport: nextSelectedSport });
  }
}
